import { toast } from "@/components/ui";
import { Button } from "@/components/ui/Button";
import { useS3SyncDownload } from "@/network/useS3SyncDownload";
import { File } from "lucide-react";

export const DownloadReport = ({
  pdfUrl,
  buttonText = "Report",
}: {
  pdfUrl: string;
  buttonText?: string;
}) => {
  const { mutateAsync: downloadDxReportPdf, isPending: isDownloadingPdf } =
    useS3SyncDownload();

  const handleDownloadDxReportPdf = async (pdfUrl: string) => {
    downloadDxReportPdf({ path: pdfUrl })
      .then((data) => {
        const url = URL.createObjectURL(data);
        window.open(url, "_blank");
      })
      .catch(() => {
        toast.error("Failed to download report.");
      });
  };

  return (
    <Button
      key="download-pdf"
      size="sm"
      variant="secondary"
      leftIcon={File}
      onClick={() => {
        handleDownloadDxReportPdf(pdfUrl);
      }}
      isLoading={isDownloadingPdf}
    >
      {buttonText}
    </Button>
  );
};
